import React from 'react';
import { ScoreChip } from '../common/ScoreChip';
import { formatDate } from '../../utils/format';
import { reportTypeLabels } from '../../utils/reportBuilder';
import type { GeneratedReport } from '../../types/ai';
export function ReportDocument({
  report
}: {
  report: GeneratedReport;
}) {
  return <article className="rounded-sm border border-border bg-card" data-id="element-154" data-mp="wwl5khfm657b">
      <header className="border-b border-border px-5 py-4" data-id="element-155" data-mp="wu8n835y1stq">
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground" data-id="element-156" data-mp="rxroyg515y2x">
          Strategic Delivery Unit · {reportTypeLabels[report.type]}
        </p>
        <h3 className="mt-1 text-lg font-semibold tracking-tight" data-id="element-157" data-mp="iviiq2gsoqvc">{report.title}</h3>
        <dl className="mt-3 flex flex-wrap gap-x-6 gap-y-1 text-[11px] text-muted-foreground" data-id="element-158" data-mp="dxqnaygxymme">
          <div className="flex gap-1.5" data-id="element-159" data-mp="2dausr884dnwk">
            <dt data-id="element-160" data-mp="2d9t6e7lnlezj">Scope:</dt>
            <dd className="text-foreground" data-id="element-161" data-mp="2d7yvlm43j396">{report.scope}</dd>
          </div>
          <div className="flex gap-1.5" data-id="element-162" data-mp="28c1dpbd6poua">
            <dt data-id="element-163" data-mp="3pzd3gom6cbar">Period:</dt>
            <dd className="text-foreground" data-id="element-164" data-mp="3py218t8dnblr">{report.period}</dd>
          </div>
          <div className="flex gap-1.5" data-id="element-165" data-mp="3u1855u80oqp2">
            <dt data-id="element-166" data-mp="3u29sax2b53n5">Audience:</dt>
            <dd className="text-foreground" data-id="element-167" data-mp="3tydn29ch7hyt">{report.audience}</dd>
          </div>
          <div className="flex gap-1.5" data-id="element-168" data-mp="3g2s1yd9d5ibo">
            <dt data-id="element-169" data-mp="3kzidcna83pqr">Generated:</dt>
            <dd className="text-foreground" data-id="element-170" data-mp="3l0tj2sn8b7ki">{formatDate(report.createdOn)}</dd>
          </div>
        </dl>
      </header>

      <div className="space-y-6 px-5 py-5" data-id="element-171" data-mp="cl0ar131x2ej">
        <section data-id="element-172" data-mp="hjtgg7c3jp45">
          <h4 className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted-foreground" data-id="element-173" data-mp="hi9xua2yx1z7">
            1 · Executive summary
          </h4>
          <p className="mt-2 text-[13px] leading-relaxed" data-id="element-174" data-mp="2sktk5zkwhup">{report.executiveSummary}</p>
        </section>

        <section data-id="element-175" data-mp="vj2vv4shaf72">
          <h4 className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted-foreground" data-id="element-176" data-mp="vikqninu8qn0">
            2 · Findings
          </h4>
          <ul className="mt-2 space-y-2.5" data-id="element-177" data-mp="10bdvs7n7y0zm">
            {report.findings.map(finding => <li key={finding.id} className="border-l-2 border-uae-green pl-3" data-id="element-178" data-mp="1a4gnaum94ygj">
                <p className="text-[13px] font-medium" data-id="element-179" data-mp="157qacg5quizc">{finding.label}</p>
                <p className="mt-0.5 text-[12px] leading-relaxed text-muted-foreground" data-id="element-180" data-mp="107c2ay45791b">
                  {finding.detail}
                </p>
              </li>)}
          </ul>
        </section>

        <section data-id="element-181" data-mp="r7flfinzvegt">
          <h4 className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted-foreground" data-id="element-182" data-mp="r7yzupefrkq3">
            3 · Scored comparison
          </h4>
          <div className="mt-2 overflow-x-auto" data-id="element-183" data-mp="mee3t2wel0tj">
            <table className="w-full border-collapse text-left" data-id="element-184" data-mp="hi5nhm6gz1ks">
              <thead data-id="element-185" data-mp="cib0vutq8y5j">
                <tr className="border-b border-border" data-id="element-186" data-mp="cj2ke7a1v5fg">
                  <th className="py-2 pr-3 text-[11px] font-medium text-muted-foreground" data-id="element-187" data-mp="cg6p6qpl6uup">
                    Subject
                  </th>
                  <th className="py-2 pr-3 text-[11px] font-medium text-muted-foreground" data-id="element-188" data-mp="3ie5zbgqv321">
                    Score
                  </th>
                  <th className="py-2 pr-3 text-[11px] font-medium text-muted-foreground" data-id="element-189" data-mp="2f6ssen2nj5ky">
                    Band
                  </th>
                  <th className="py-2 text-[11px] font-medium text-muted-foreground" data-id="element-190" data-mp="2o4v0fmksyyhq">Note</th>
                </tr>
              </thead>
              <tbody data-id="element-191" data-mp="2t366dm7z8ouo">
                {report.scoredRows.map(row => <tr key={row.subject} className="border-b border-border last:border-0" data-id="element-192" data-mp="1wezzstrhvmdr">
                    <td className="py-2 pr-3 text-[12px]" data-id="element-193" data-mp="20fagb0cwxv6v">{row.subject}</td>
                    <td className="py-2 pr-3" data-id="element-194" data-mp="25eveh8k9dzij">
                      <ScoreChip score={row.score} data-id="element-195" data-mp="25e3ivxqnw1s9" />
                    </td>
                    <td className="py-2 pr-3 text-[12px] text-muted-foreground" data-id="element-196" data-mp="2a5vb0cpgufki">{row.band}</td>
                    <td className="py-2 text-[12px] text-muted-foreground" data-id="element-197" data-mp="1cqr80ktv5ies">{row.note}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </section>

        <section data-id="element-198" data-mp="3kb6fhia52u6g">
          <h4 className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted-foreground" data-id="element-199" data-mp="3kcraf90d8f4u">
            4 · Recommendations
          </h4>
          <ol className="mt-2 list-decimal space-y-1.5 pl-5" data-id="element-200" data-mp="3t49p1fhnymvt">
            {report.recommendations.map(recommendation => <li key={recommendation} className="text-[13px] leading-relaxed" data-id="element-201" data-mp="3od1icr7pxfmc">
                {recommendation}
              </li>)}
          </ol>
        </section>

        <section data-id="element-202" data-mp="1xyu8138yicx">
          <h4 className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted-foreground" data-id="element-203" data-mp="1yi2eq33hsdr">
            5 · Appendix
          </h4>
          <ul className="mt-2 space-y-1 text-[12px] text-muted-foreground" data-id="element-204" data-mp="fwyj99uo8z9m">
            {report.appendix.map(item => <li key={item} data-id="element-205" data-mp="bubnwyyskw7o">· {item}</li>)}
          </ul>
        </section>
      </div>
    </article>;
}